import React, { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';

import { DropdownListPickerProps } from './types';

function DropdownListPicker({
  className,
  list,
  onClick,
  onClose,
  activeValue,
}: DropdownListPickerProps) {
  const componentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (
        componentRef.current &&
        !componentRef.current.contains(event.target)
      ) {
        onClose?.();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleItemClick = (value: string) => {
    onClick?.(value);
  };

  return (
    <Component ref={componentRef} className={className}>
      <List>
        {list.length > 0 ? (
          list.map((listItem, index) => (
            <Item
              key={index}
              isActive={listItem === activeValue}
              onClick={() => handleItemClick(listItem)}
            >
              {listItem}
            </Item>
          ))
        ) : (
          <Item>No items</Item>
        )}
      </List>
    </Component>
  );
}

export default DropdownListPicker;

const Component = styled.div`
  z-index: 10;
  width: 100%;
  background: ${(props) => props.theme.white_1};
  border: 1px solid ${(props) => props.theme.black200_alpha40_1};
  box-shadow: ${(props) => props.theme.blackShadow100};
  height: 200px;
  overflow-y: auto;
`;

const List = styled.div`
  z-index: 10;
  display: flex;
  flex-direction: column;
`;

const Item = styled.div<{ isActive?: boolean }>`
  padding: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: ${(props) => props.theme.black};

  ${({ isActive }) =>
    isActive &&
    css`
      background: ${(props) => props.theme.gray};
    `}
`;
